import _ from "lodash";
import React, { useContext, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import axiosInstance from "../../../utils/Requests/axios";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import RightArrow from "../../svg/RightArrow";

function Announcement() {
  const [announcementData, setAnnouncementData] = useState(null);
  const { t } = useContext(LanguageContext);
  const announcementPayload = {
    length: 5,
    columns: [{ data: "created" }],
    order: [{ column: 0, dir: "desc" }],
    search: {
      filters: [
        { key: "TYPE", value: 100 },
        { key: "CATEGORY", value: "ANNOUNCEMENT" },
      ],
    },
  };

  const announcementsFetched = useRef(false);

  const fetchAnnouncements = () => {
    if (announcementsFetched.current) return;
    announcementsFetched.current = true;
    const payload = _.cloneDeep(announcementPayload);
    const url = `projects/backlinksfactory/articles/search`;
    axiosInstance
      .post(url, payload)
      .then((response) => {
        setAnnouncementData(response?.data?.data);
      })
      .catch(() => {
        toast.error(t("There was an error fetching backlinks offers"));
      });
  };

  useEffect(() => {
    fetchAnnouncements();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      id="announcementCarousel"
      className="carousel slide custom-height-announcement"
      data-bs-ride="carousel"
    >
      <div className="carousel-inner h-100">
        {!!announcementData?.length &&
          announcementData?.map((item, index) => (
            <div
              key={item.uuid}
              className={`carousel-item h-100 ${index === 0 ? "active" : ""}`}
            >
              <div
                className="h-100 p-4 d-flex flex-column"
                style={{
                  backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.9)), url(${item.thumbnail})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderRadius: "10px",
                }}
              >
                <span className="announcement-badge">{t("Announcement")}</span>

                <div>
                  <h2 className="title-announcement">{item.title}</h2>
                  <p className="excerpt-announcement">{item.excerpt}</p>
                </div>
                <p className="read-more text-primary cursor-pointer d-flex align-items-center">
                  {t("Read More")} <RightArrow />
                </p>
              </div>
            </div>
          ))}
      </div>
      <div
        className="carousel-indicators px-4"
        style={{ marginLeft: "unset", right: "unset", marginBottom: "2rem" }}
      >
        {!!announcementData?.length &&
          announcementData?.map((_, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#announcementCarousel"
              data-bs-slide-to={index}
              className={`custom-indicator ${index === 0 ? "active" : ""}`}
              aria-current={index === 0 ? "true" : "false"}
              aria-label={`Slide ${index + 1}`}
            ></button>
          ))}
      </div>
    </div>
  );
}

export default Announcement;
